import Modal from "@containers/shipments/components/RightPanel/components/SaveSearch/component/Modal";
import { saveSearchCall } from "@containers/shipments/components/RightPanel/components/SaveSearch/services";
import CheckboxSelect from "@shared/country-components/CheckboxSelect";
import { useState } from "react";
import { toast } from "react-toastify";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";

const TABENUM = {
  current: "current",
  shared: "shared",
};
const ShareSearch = ({ isOpen, onClose, currentItem, shareUserOptions, getDashboardContacts, type }) => {
  const [selectedShareUser, setSelectedShareUser] = useState([]);
  const updateSaveSearch = async () => {
    trademoTrackingEvents(trackingEventDictionary.dashboardSearchHistoryShareSavedSearchSharedWithMeConfirm, { ...generateTrackingObject(window?.location?.pathname) });

    const requestObject = JSON.parse(JSON.stringify(currentItem));
    requestObject.is_shared = true;
    requestObject.shared_with = [...(currentItem?.shared_with ?? []), ...(selectedShareUser?.map((user) => user?.value) ?? [])];
    requestObject.is_shared_from_save_search = false;
    const response = await saveSearchCall(requestObject);
    if (response.status === "success") {
      toast.success("Saved Search has been shared with your team");
      onClose();
      getDashboardContacts();
    } else {
      toast.error(response.message);
    }
  };
  function removeMatchingRecords(largeArray, matchRecords) {
    const matchSet = new Set(matchRecords?.map((record) => record?.userId));
    return largeArray?.filter((item) => !matchSet?.has(item?.value?.userId));
  }

  function removeMatchingRecordsFromSharedWith(largeArray, matchRecord) {
    return largeArray.filter((item) => item?.value?.userId !== matchRecord?.shared_by);
  }

  return (
    <div>
      <Modal size={"small"} title="Share this search with your team " isOpen={isOpen} onClose={onClose} footerComponent={null}>
        <div className="tw-flex tw-flex-col tw-gap-5">
          <div className="tw-flex tw-flex-row tw-justify-start tw-items-center tw-gap-2 tw-p-0">
            <div className="w-100">
              <CheckboxSelect options={type === TABENUM.current ? removeMatchingRecords(shareUserOptions, currentItem?.shared_with) : removeMatchingRecordsFromSharedWith(shareUserOptions, currentItem)} placeholder="Select users from the list. You can select multiple" className="match-type" onChange={(value) => setSelectedShareUser(value || [])} value={selectedShareUser} maxSelection={shareUserOptions?.length ?? 0} />
            </div>
            <button className="tw-px-4 tw-py-[10px] tw-rounded-lg tw-shadow-[0_2px_8px_0_rgba(66,48,125,0.3)] tw-bg-primary-purple-500 tw-text-sm tw-font-medium tw-leading-[1.43] tw-text-white disabled:tw-opacity-50 disabled:tw-cursor-not-allowed" disabled={selectedShareUser?.length === 0} onClick={updateSaveSearch}>
              Share
            </button>
          </div>
          {currentItem?.shared_with?.length > 0 && (
            <div className="tw-flex tw-flex-col">
              <div className="tw-text-sm tw-font-medium tw-leading-[1.43] tw-tracking-[-0.14px] tw-text-gray-900 tw-px-2 tw-py-[10px] tw-bg-white tw-flex tw-gap-2 tw-items-center">Search shared with</div>
              {currentItem.shared_with.map((item) => (
                <div key={item?.email} className="tw-text-sm tw-font-medium tw-leading-[1.43] tw-tracking-[-0.14px] tw-text-gray-600 tw-px-2 tw-py-[10px] tw-bg-white tw-flex tw-gap-2 tw-items-center">
                  <div className="tw-rounded-xl tw-w-6 tw-h-6 tw-flex tw-flex-col tw-justify-center tw-items-center tw-text-base tw-font-medium tw-bg-avatar-bg tw-text-gray-100 tw-px-[7px]">{item?.name?.substring(0, 1)}</div>
                  {item?.name}
                  <span>({item?.email})</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ShareSearch;
